// Components==============
import React, { useContext } from 'react';
import Avatar from '../../Avatar/Avatar';
import { AddUserModalContext } from '../AddUserModal';
import './User.module.scss';
// =========================

export default function User({ user }: { user: UserEntity }) {
  const { selectedUsers, setSelectedUsers, value, message } = useContext(
    AddUserModalContext
  );

  const boldString = (string: string, query?: string) => {
    if (!query) return string;

    const n = string.toUpperCase();
    const q = query.toUpperCase();
    const x = n.indexOf(q);
    if (!q || x === -1) {
      return string; // bail early
    }
    const l = q.length;
    return `${string.substr(0, x)}<strong>${string.substr(
      x,
      l
    )}</strong>${string.substr(x + l)}`;
  };

  const name = `${user.first_name} ${user.last_name}`;
  const boldName = boldString(name, value);

  const displayMessage = message(user);
  const isSelected = displayMessage
    ? true
    : selectedUsers.map((s) => s.id).includes(user.id);

  const isTeacher =
    user.roles.map((r) => r.name).includes('Docent') ||
    user.roles.map((r) => r.name).includes('super-admin');

  const isExtern = user.roles.map((r) => r.name).includes('Extern');

  return (
    <div
      style={{
        pointerEvents: displayMessage ? 'none' : 'all',
        opacity: displayMessage ? 0.5 : 1,
      }}
      onClick={() =>
        setSelectedUsers((prev) =>
          prev.map((p) => p.id).includes(user.id)
            ? prev.filter((p) => p.id !== user.id)
            : [...prev, user]
        )
      }
    >
      <div
        styleName="wrapper"
        style={{
          backgroundColor: isSelected ? '#ececec' : 'initial',
        }}
      >
        <Avatar user={user} />
        <div
          dangerouslySetInnerHTML={{
            __html: `${boldName}${displayMessage}`,
          }}
        />
        <p>{isTeacher ? 'Docent' : isExtern ? 'Extern' : 'Student'}</p>
      </div>
    </div>
  );
}
